module.exports = __webpack_public_path__ + "static/img/mk74rd.d8c0ace.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/mk74rd.jpg
// module id = UTzb
// module chunks = 0